import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import {
  AirlineStops as AirlineStopsIcon,
  MailOutline as MailOutlineIcon,
  Mouse as MouseIcon,
  PeopleAltOutlined as PeopleAltOutlinedIcon,
  Unsubscribe as UnsubscribeIcon,
} from '@mui/icons-material';

import { broadcastsSelectors } from 'store/selectors/broadcasts';

import { StatisticTiles } from 'common/components';

import { colors } from 'utils/constants';
import { CardWrapper } from 'globalStyles';

const StatisticWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 40px;
`;

const Title = styled.h2`
  margin-bottom: 20px;
  font-weight: 400;
  font-size: 20px;
`;

const BroadcastOverview = () => {
  const { broadcastDetails } = useSelector(state => ({
    broadcastDetails: broadcastsSelectors.getBroadcastDetails(state),
  }));

  const {
    totalBouncedCount,
    totalClickedCount,
    totalRecipientsCount,
    totalOpenedCount,
    totalUnsubscribedCount,
  } = broadcastDetails;

  const tiles = useMemo(
    () => [
      {
        count: totalRecipientsCount,
        icon: (
          <PeopleAltOutlinedIcon
            color="blue"
            sx={{
              fontSize: 16,
            }}
          />
        ),
        iconColor: colors.people,
        name: 'Recipients',
      },
      {
        count: totalOpenedCount,
        icon: (
          <MailOutlineIcon
            color="green"
            sx={{
              fontSize: 16,
            }}
          />
        ),
        iconColor: colors.greenBackground,
        name: 'Opened',
      },
      {
        count: totalClickedCount,
        icon: (
          <MouseIcon
            color="yellow"
            sx={{
              fontSize: 16,
            }}
          />
        ),
        iconColor: colors.yellowBackground,
        name: 'Clicked',
      },
      {
        count: totalBouncedCount,
        icon: (
          <AirlineStopsIcon
            color="green"
            sx={{
              fontSize: 16,
            }}
          />
        ),
        iconColor: colors.greenBackground,
        name: 'Bounced',
      },
      {
        count: totalUnsubscribedCount,
        icon: (
          <UnsubscribeIcon
            color="error"
            sx={{
              fontSize: 16,
            }}
          />
        ),
        iconColor: colors.errorBackground,
        name: 'Unsubscribed',
      },
    ],
    [
      totalBouncedCount,
      totalClickedCount,
      totalRecipientsCount,
      totalOpenedCount,
      totalUnsubscribedCount,
    ]
  );

  return (
    <CardWrapper>
      <Title>Overview</Title>
      <StatisticWrapper>
        <StatisticTiles tiles={tiles} />
      </StatisticWrapper>
    </CardWrapper>
  );
};

export default BroadcastOverview;
